import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

// import FeedbackIcon from "@mui/icons-material/Feedback";

const componentStyles = theme => ({
  dialogPaper: {
    borderRadius: 0
  },
  headerPaper: {
    height: 90,
    width: 90,
    backgroundColor: "#1c355e",
    zIndex: 9
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    width: 260,
    marginTop: -50,
    borderRadius: 0
  },
  cardHeader: {
    fontSize: 20,
    marginTop: 55,
    fontWeight: 600
  },
  headerImage: {
    width: 70,
    height: 70,
    color: "#fff",
    marginTop: 10,
    marginLeft: 10
  },
  divideMe: {
    marginTop: 10,
    marginBottom: 10
  }
});
const StyledRoot = styled("div")(({
  theme
}) => ({
  display: "contents",
  ...Object.entries(componentStyles(theme)).reduce((acc, [className, style]) => ({
    ...acc,
    [`& .${className}, &.${className}`]: style
  }), {})
}));
export const ConfirmationDialog = props => {
  const {
    title,
    children,
    showHelp,
    alert,
    confirmBtnLabel,
    cancelBtnLabel,
    open,
    setOpen,
    onConfirm,
    onCancel
  } = props;
  const {
    t
  } = useTranslation();
  ConfirmationDialog.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.string,
    showHelp: PropTypes.bool,
    alert: PropTypes.string,
    confirmBtnLabel: PropTypes.string,
    cancelBtnLabel: PropTypes.string,
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func
  };
  return <StyledRoot>
    <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby="confirmation-dialog" classes={{
      paper: "dialogPaper"
    }}>
      <Grid container className={"pageHolder"} sx={{
        flexDirection: "column"
      }}>
        {/* <Grid item>
          <Grid
            container
            style={{ width: 300, backgroundColor: "currentColor" }}
          >
            <Grid
              item
              className={"headerPaper"}
              style={{ marginLeft: 105 }}
            >
              <FeedbackIcon className={"headerImage"} />
            </Grid>
          </Grid>
         </Grid> */}
        <Grid>
          <Grid container sx={{
            flexDirection: "column"
          }}>
            <Grid>
              <Paper className={"paper"} elevation={0}>
                <Grid container sx={{
                  flexDirection: "column"
                }}>
                  <Grid>
                    <Typography className={"cardHeader"}>
                      {title}
                    </Typography>
                  </Grid>
                  <Divider className={"divideMe"} />
                  <Grid>
                    {children === undefined ? "" : children.split("\n").map((i, key) => {
                      return <div key={key} style={{
                        minHeight: 20
                      }}>
                              {i.length > 0 ? i : "\u00A0"}
                            </div>;
                    })}
                  </Grid>
                  <Grid>
                    {alert === undefined ? "" : alert.split("\n").map((i, key) => {
                      return <div key={key} style={{
                        minHeight: 20,
                        color: "#d1495b",
                        fontStyle: "italic"
                      }}>
                              {i.length > 0 ? i : "\u00A0"}
                            </div>;
                    })}
                  </Grid>
                  {showHelp !== true ? "" : <Grid>
                      {t("documents.showHelpText")}
                      <RouterLink to="help">
                        {t("documents.showHelpLinkText")}
                      </RouterLink>
                    </Grid>}
                  <Grid container style={{
                    marginTop: 20
                  }} sx={{
                    flexDirection: "row"
                  }}>
                    {cancelBtnLabel === "Hidden" ? <Grid size={{
                      xs: 12
                    }}>
                        <Button size="medium" variant="contained" color="primary" onClick={() => {
                        setOpen(false);
                        onConfirm();
                      }}>
                          {confirmBtnLabel === undefined ? "Yes" : confirmBtnLabel}
                        </Button>
                      </Grid> : <>
                        <Grid style={{
                        paddingLeft: 30
                      }} size={{
                        xs: 6
                      }}>
                          <Button size="medium" variant="contained" color="primary" onClick={() => {
                          setOpen(false);
                          onConfirm();
                        }}>
                            {confirmBtnLabel === undefined ? t("home.yesButton") : confirmBtnLabel}
                          </Button>
                        </Grid>
                        <Grid style={{
                        paddingRight: 30
                      }} size={{
                        xs: 6
                      }}>
                          <Button size="medium" variant="contained" color="secondary" onClick={() => {
                          setOpen(false);
                          {
                            onCancel !== undefined ? onCancel() : "";
                          }
                        }}>
                            {cancelBtnLabel === undefined ? "No" : cancelBtnLabel}
                          </Button>
                        </Grid>
                      </>}
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  
    </StyledRoot>;
};
